<app-loading-guard [loading]="loading">
  <app-authorized-guard [authorized]="!unauthorized">
    <mat-toolbar class="page-header">
      <div class="button-bar">
        <a
          mat-raised-button
          *hasPrivilege="'subscription/update'"
          (click)="updatePaymentInfo()"
        >
          Update Payment Info
        </a>
        <a
          mat-raised-button
          *hasPrivilege="'subscription/update'"
          [routerLink]="['/subscription', 'change_plan']"
        >
          Change Plan
        </a>
        <button
          mat-raised-button
          *hasPrivilege="'subscription/destroy'"
          (click)="confirmCancelPlan()"
        >
          Cancel Plan
        </button>
      </div>
    </mat-toolbar>
    <div *ngIf="item$ | async as item">
      <ng-container *ngIf="item.status === 'past_due'">
        <mat-card appearance="outlined" class="error-card subscription-card">
          <mat-card-content>
            <p>
              Your subscription is past due - please ensure your payment method
              is up to date. Contact
              <a href="mailto: support@kahi.io">support&#64;kahi.io</a> for all
              billing and support assistance.
            </p>
          </mat-card-content>
        </mat-card>
      </ng-container>
      <mat-card appearance="outlined" class="subscription-card">
        <mat-card-content>
          <dl class="details-list">
            <dt>Status</dt>
            <dd>{{ item.status | titlecase }}</dd>
            <dt>Next Payment</dt>
            <dd>{{ item.current_period_end_at | date : dateFormat }}</dd>
          </dl>
        </mat-card-content>
      </mat-card>
      <mat-card appearance="outlined" class="subscription-card">
        <mat-card-title>Plan</mat-card-title>
        <mat-card-content>
          <dl class="details-list">
            <dt>Name</dt>
            <dd>{{ item.plan.metadata.title }}</dd>
            <dt>Period</dt>
            <dd>{{ item.plan.metadata.period }}</dd>
          </dl>
        </mat-card-content>
      </mat-card>
      <mat-card
        appearance="outlined"
        class="subscription-card"
        *ngIf="item.payment_method"
      >
        <mat-card-title>Payment Method</mat-card-title>
        <mat-card-content>
          <dl class="details-list">
            <dt>Card Type</dt>
            <dd>{{ item.payment_method.brand | titlecase }}</dd>
            <dt>Expiry</dt>
            <dd>
              {{ item.payment_method.exp_month }}/{{
                item.payment_method.exp_year
              }}
            </dd>
            <dt>Last 4 Digits</dt>
            <dd>{{ item.payment_method.last4 }}</dd>
          </dl>
        </mat-card-content>
      </mat-card>
    </div>
  </app-authorized-guard>
</app-loading-guard>
